class TagList {
	static RESOURCES = 1; 
	static GRAPHICS = 2;

	constructor(itemType, itemList) {
		this._itemList = itemList;

		this._editList = new OrderedList();
		this._checkList = new OrderedList(null, 'orderBy', 'chkElem');

		this._dialog = Dialog.Modal('tags', _("Tags"), LARGE, null, [
			this._editList.container,
			this._newButton1 = UI.priIconBtn('plus-square', 22)
		]);
		
		this._popup = Dialog.Popup([
			this._checkList.container,
			this._newName = UI.div(null, [
				UI.p('text-sm', _("Name")),
				this._newNameInput = UI.text(''),
				this._newSave = UI.btn('popup-list-btn', _("Save"))
			]),
			this._newButton2 = UI.priIconBtn('plus-square', 22)
		], 'left-start', _("TAGS")).sticky();
		
		this._newName.style.display = 'none';

		onEv(this._newButton1, 'click', this.newInEdit.bind(this));
		onEv(this._newButton2, 'click', this.newInCheck.bind(this));
		onEv(this._newNameInput, 'paste', event => {
			this._newSave.disabled = event.clipboardData.getData('text').length == 0;
		});
		onEv(this._newNameInput, 'keyup', event => {
			switch (event.keyCode) {
				case AC.ENTER_KEY: this.saveInCheck(); break;
				case AC.ESCAPE_KEY: this.cancelInCheck(); break;
			}
			this._newSave.disabled = this._newNameInput.value === '';
		})

		onEv(this._newSave, 'click', this.saveInCheck.bind(this));
		
		this._itemType = itemType;
		this._selectionIds = null;

		this._activeTag = null;
		this._filterGroup = false;
		
		this.init();
	}

	set filterGroup(value) {
		this._filterGroup = value;
	}

	get filters() {
		return [[-2, _("Untagged")], ...this._editList.items.map(i => [i.id, i.name])];
	}
	
	init (){
		API.fetch('tags')
		.then(reply => {
			if(reply.tags && Array.isArray(reply.tags)) {
				reply.tags.forEach(data => {
					let tag = Tag.fromArray(data, this);
					this._editList.addItem(tag);
					this._checkList.addItem(tag);
				});
				if (this._filterGroup) {
					this._filterGroup.update();
					this._filterGroup.initialized = true;
				}
			}
		});
    }

	openDialog() {
		this._selectionIds = null;
		this._dialog.open();
		this._editList.update();
	}

	reset() {
		this._editList.forEach(t => t.reset());
	}

	increment(id, max) {
		this._editList.gotoId(id).item.increment(max);
	}

	popup(button) {
		this._popup.handle(button);
	}


	newInEdit () {
		let tag = Tag.blank(this);
		this._editList.addItem(tag, tag.getOrder, tag.getRow, tag.getDrag);
		this._checkList.addItem(tag, tag.getOrder, tag.getChkRow);
		tag.edit();
	}

	newInCheck () {
        this._newName.style.display = 'block';
		this._newButton2.style.display = 'none';
		this._newSave.disabled = this._newNameInput.value === '';
		this._newNameInput.select();
    }

	cancelInCheck () {
		this._newNameInput.value = '';
		this.saveInCheck();
	}

	saveInCheck () {
		if (this._newNameInput.value.length) {
			let tag = Tag.blank(this);
			tag.name = this._newNameInput.value;
			this._editList.addItem(tag);
			this._checkList.addItem(tag, tag.getOrder, tag.getChkRow);
			tag.save();
			this._newNameInput.value = '';
		}
		this._newName.style.display = 'none';
		this._newButton2.style.display = 'block';
	}

	remove(tag) {
		this._editList.removeItem(tag);
		this._checkList.removeItem(tag);
	}

	prepDrag(row, ev) {
		if (this._activeTag !== null) return;
		this._editList.prepDrag(row, ev);
	}

	// This function was WIP commented out to avoid accidental use.
	//
	// applyFilter (){
    //     var match = new RegExp('^'+this.filterText.value,'gi');
    //     if (this.list.moveFirst()) do {
    //         if (
    //             this.filterText === '' ||
    //             this.list.getItem().getName().match(match)
    //         ) {
    //             this.list.getItem().show();
    //         } else {
    //             this.list.getItem().hide();
    //         }
    //     } while (this.list.moveNext())
    // }
}